module.exports = __webpack_public_path__ + "static/media/bts_lalela_170706_012_small.c4df092f.jpg";